<template>
  <div class="text-container">
    <div
      class="card-item"
      v-for="(item, ind) in list"
      :key="ind"
      @click="handleShowPreview(item)"
      >
      <div class="left-img" id="canvas" :ref="'canvas' + ind + 'Img'">
        <img src="https://oss2.nrtatalent.cn/public/product/6wZNdJy8Ax.jpg" alt="">
      </div>
      <div class="right-info">
        <div class="info-box">
          <p class="title">姓名：{{ item.name }}</p>
          <p>证书类型：<span>{{ item.templateName }}</span></p>
          <p class="wrap">培训班名称：<span></span>{{ item.className }}</p>
          <p>证书编号：<span>{{ item.graduationNumber }}</span></p>
          <p>身份证号：<span>{{ item.idCard }}</span></p>
        </div>
      </div>
    </div>
    <preview :showPic="showPreview" :info="info" @showPic="handleHidePic"></preview>
  </div>
</template>

<script>
import Preview from './preview'
export default {
  props: {
    list: {
      type: Array
    }
  },
  components: {
    Preview
  },
  data() {
    return {
      showPreview: false,
      info: {}
    }
  },
  methods: {
    handleHidePic(info) {
      this.showPreview = false
    },
    handleShowPreview(item) {
      this.showPreview = true
      this.info = item
    }
  }
}
</script>

<style lang="scss" scoped>
.text-container {
  max-width: 1080px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  .certificate-box {
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    position: relative;
    font-family:LiSu;
    &>div {
      position: absolute;
    }
    .content {
      text-indent:2em;
      padding-left: 60px;
      padding-right: 60px;
      line-height: 2;
      letter-spacing:1px;
    }
  }
  .card-item {
    max-width: 530px;
    padding: 30px 20px;
    background-color: #EFF6FF;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    margin-top: 20px;
    cursor: pointer;
    .left-img {
      width: 250px;
      height: 180px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .right-info {
      margin-left: 10px;
      .info-box {
        height: 180px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .title {
          color: #0853B6;
          font-size: 16px;
          font-weight: bold;
        }
        p {
          // margin: 15px 0;
          font-size: 14px;
          color: #333;
          line-height: 24px;
          font-weight: bold;
          display: flex;
          flex-direction: row;
          white-space: normal;
          word-break: break-all;
          word-wrap: break-word;
        }
        .wrap {
          width: 230px;
          overflow:hidden;
          text-overflow:ellipsis;
          display:-webkit-box;
          -webkit-box-orient:vertical;
          -webkit-line-clamp:2;
        }

      }
    }
  }
}
</style>
